let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f59bk")).then(() => parcelRequire('1z9k6'));